import axios from "axios";
import { setAgenda } from "../reducers/agenda.reducer";

const URL = process.env.REACT_APP_CORE;

export const getAgenda =
  (userId, page = 1, elements = 10) =>
  async (dispatch) => {
    dispatch(
      setAgenda({
        data: [],
        isLoading: true,
        error: null,
        pagination: { page: 1, lastPage: 1 },
      })
    );

    try {
      const response = await axios.get(`${URL}agendasWalletsExternas`, {
        params: {
          usuarioid: userId,
          page,
          elements,
        },
      });
      dispatch(
        setAgenda({
          data: response?.data?.data,
          isLoading: false,
          error: null,
          pagination: {
            page: response?.data?.pagination?.page,
            lastPage: Math.ceil(
              response?.data?.pagination?.totalObjects / elements
            ),
          },
        })
      );
    } catch (error) {
      dispatch(
        setAgenda({
          data: [],
          isLoading: false,
          error:
            error.response?.data?.message ||
            error.message ||
            "Error getting agenda",
          pagination: { page: 1, lastPage: 1 },
        })
      );
    }
  };

export const deleteContactAgenda = (id, userId) => async (dispatch) => {
  try {
    await axios.delete(`${URL}agendasWalletsExternasportal/${id}`);
    dispatch(getAgenda(userId));
  } catch (error) {
    return error;
  }
};

export const createContactAgenda = (contact, userId) => async (dispatch) => {
  try {
    await axios.post(
      `${URL}agendasWalletsExternas`,
      {
        walletadress: contact.walletadress,
        nombre: contact.nombre,
        apellido: contact.apellido,
        email: contact.email,
        alias: contact.alias,
        usuarioid: userId?.toString(),
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch(getAgenda(userId));
  } catch (error) {
    return error;
  }
};

export const editContactAgenda =
  (id, updatedFields, userId) => async (dispatch) => {
    try {
      await axios.put(
        `${URL}agendasWalletsExternasportal/${id}`,
        updatedFields,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(getAgenda(userId));
    } catch (error) {
      return error;
    }
  };
